import { expVal } from '@atlassian/jira-feature-experiments';
import { useShouldShowImporter } from '../use-should-show-importer/index.tsx';

export const useIsImportersOnProjectDirectoryEnabled = () => {
	return (
		useShouldShowImporter() &&
		expVal('importer_discovery_projects_directory_cta', 'isEnabled', false)
	);
};
